import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.16 8.667c-.147 0-.3-.047-.447-.08a6 6 0 0 1-.873-.26 1.333 1.333 0 0 0-1.654.666l-.146.3A8.1 8.1 0 0 1 8.266 7.96a8.1 8.1 0 0 1-1.333-1.773L7.213 6a1.333 1.333 0 0 0 .667-1.653 7 7 0 0 1-.26-.874c-.034-.146-.06-.3-.08-.453a2 2 0 0 0-2-1.66h-2a2 2 0 0 0-2 2.273 12.67 12.67 0 0 0 11.013 10.974h.253a2 2 0 0 0 1.828-1.185 2 2 0 0 0 .172-.822v-2a2 2 0 0 0-1.646-1.933m.333 4a.67.67 0 0 1-.482.64.7.7 0 0 1-.291.026A11.33 11.33 0 0 1 2.913 3.48a.73.73 0 0 1 .167-.547.67.67 0 0 1 .5-.226h2a.67.67 0 0 1 .666.526q.04.274.1.54.116.528.307 1.034l-.933.433a.667.667 0 0 0-.327.887 9.66 9.66 0 0 0 4.667 4.666.67.67 0 0 0 .506 0 .67.67 0 0 0 .38-.346l.414-.934a9 9 0 0 0 1.053.307q.267.06.54.1a.67.67 0 0 1 .527.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })